module.exports = __webpack_public_path__ + "static/img/m8.59e29c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/mobile/m8.png
// module id = WYo4
// module chunks = 12